<template>
  <router-link
    v-slot="{
      href, navigate,
    }"
    :to="{
      name: ERouteName.HOME,
    }"
    custom
  >
    <a
      :href="href"
      :title="i18n.global.t('page.home.title')"
      @click="navigate"
    >
      <QmulusLogo style="width: 177px; height: 40px;" />
    </a>
  </router-link>
</template>

<script setup lang="ts">
import {
  i18n,
} from '@i18n';
import QmulusLogo from '@qmulus/ui/components/logo-qmulus/logo-qmulus.vue';

import {
  ERouteName,
} from '@/router/route-name.ts';
</script>
